import { getToken } from "./auth"
import { API_BASE_URL } from "../config"

export async function fetchMetrics(token: string) {
  const res = await fetch(`${API_BASE_URL}/admin-api/reports/metrics`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  })
  if (!res.ok) {
    throw new Error("No se pudieron obtener las métricas")
  }
  return res.json()
}

export async function fetchExportJobs(token: string) {
  const res = await fetch(`${API_BASE_URL}/admin-api/reports/export`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  })
  if (!res.ok) {
    throw new Error("No se pudieron obtener los trabajos de exportación")
  }
  return res.json()
}

export async function requestExport(token: string, fields: string[]) {
  const res = await fetch(`${API_BASE_URL}/admin-api/reports/export`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    },
    body: JSON.stringify({ fields }),
  })
  if (!res.ok) {
    throw new Error("No se pudo solicitar la exportación")
  }
  return res.json()
}
